import React from 'react';
import Fallback from './Pages/Fallback';
import './Styles/styles.scss';

function App() {
  /* const dispatch = useDispatch<AppDispatch>(); */

  // custom hook to check server status
  /* const { isHealthy, messageType, message, check } = useServerStatus(); */

  // Custom Hook to check if the user is authenticated and refresh the access token.
  // During inactivity periods, the access token won't be refreshed, and after a certain time the user will be logged out.
  /* const isAuth = useAuth({ nodeEnvironment: 'development' }); */

  // user data
  /* const user = useSelector(selectUser);
  const isLoadingUser = useSelector(selectIsLoadingUser); */

  /* useEffect(() => {
    dispatch(getUserProfile());
    dispatch(getInstallerConfig());
  }, [dispatch]); */

  // set user data in bugsnag
  /* useEffect(() => {
    if (!isLoadingUser && user !== null) {
      Bugsnag.setUser(user.uuid, user.email, `${user.first_name} ${user.last_name}`);
    }
  }, [isLoadingUser, user]); */

  return (
    <>
      <Fallback />
      {/* <HashRouter>
      <Routes>
        <Route element={<ProtectedLayout isLoggedIn={isAuth} />}>
          <Route
            path='/'
            element={
              <SiteList
                isHealthy={isHealthy}
                messageType={messageType}
                message={message}
                check={check}
              />
            }
          />
          <Route path='/settings' element={<InstallerSettings />} />
        </Route>

        <Route path='*' element={<PageNotFound />} />
      </Routes>
    </HashRouter> */}
    </>
  );
}

export default App;
